import { render, staticRenderFns } from "./SluzbaWebyDetail.vue?vue&type=template&id=776d3ec6&scoped=true&"
import script from "./SluzbaWebyDetail.vue?vue&type=script&lang=js&"
export * from "./SluzbaWebyDetail.vue?vue&type=script&lang=js&"
import style0 from "./SluzbaWebyDetail.vue?vue&type=style&index=0&id=776d3ec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776d3ec6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('776d3ec6')) {
      api.createRecord('776d3ec6', component.options)
    } else {
      api.reload('776d3ec6', component.options)
    }
    module.hot.accept("./SluzbaWebyDetail.vue?vue&type=template&id=776d3ec6&scoped=true&", function () {
      api.rerender('776d3ec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/sluzby/SluzbaWebyDetail.vue"
export default component.exports